export default "__VITE_ASSET__7VoKSjCP__"